// const url = 'http://localhost:8060/';
// const url = 'http://192.168.1.60:8060/';
// const url = 'http://44.225.7.94:2056/';
const url = 'https://dmsdevapi.dosystemsinc.com/';
// const url = 'https://dmstestapi.dosystemsinc.com/';
// const url = 'https://legalaiapi.dosystemsinc.com/';
// const url = 'http://192.168.1.43:8060/';
// const url = 'https://demoapi.dosystemsinc.com/';


const config = {

  apiUrl: `${url}api/`,
  imgUrl: `${url}images/`,
  profileUrl: `${url}images/server/upload/employees/`,
  compareFilesURL: `${url}/images/server/upload/comparefiles/`,

  socketUrl: 'https://api.school.dosystemsinc.com',
  janusUrl: 'wss://janus.dosystemsinc.com:8989/janus',
  serverErrMessage: 'Could Not reach server',

  //regex
  borderValidation: false,
  messages: true,

  entityType: 'employee',

  appName: 'DMS',
  displayProjectName: true,
  displayRecaptcha: false,
  displayGoogleLogin: false,
  loginName: 'Employee',
  selectedLoginScreenName: "1",
  emailRegex: /^(?=.{1,50}$)[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
  aadharcardNumberRegex: /^([0-9]){12}$/,
  pancardNumberRegex: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  phoneNumberRegex: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
  userNameRegex: /^[a-zA-Z\s]{1,30}$/,
  lastNameRegex: /^[a-zA-Z\s]{1,30}$/,
  subjectRegex: /^[a-zA-Z\s]{1,50}$/,
  companyRegex: /^([A-Za-z0-9\s@.,]){1,30}$/,
  roomIdRegex: /^([0-9]){4,10}$/,
  // server response codes
  updateResCode: 205,
  deleteResCode: 206,

  datePlaceholder: '--/--/----',
  dateFormat: 'MM/DD/YYYY',
  dateTabularFormat: 'MMM DD YYYY',
  dateDisplayModalFormat: 'DD MMM YYYY',
  dateDBFormat: 'MM-DD-YYYY',
  recentDateFormat: 'MMM DD, YYYY hh:mm a',
  dateDayMonthFormat: 'MMM D YYYY',
  dateYearMonthFormat: 'YYYY-MM-DD',
  dayYearDateFormat: 'YYYY-MM-DD',
  basicDateFromat: 'MM/DD/YYYY HH:mm A',
  descDateFromat: 'MMM DD YYYY HH:mm A',

  timeFormat: 'HH:mm',
  syncTimeFormat: 'hh:mm A, MM-DD-YYYY',
  lastModifiedDateFormat: 'MMM D, YYYY hh:mm:ss A',
  dateTimeFormat: 'MM/DD/YYYY hh:mm',
  fullDateFormat: 'YYYY-MM-DD HH:mm:ss',
  fullDateTimeFormat: 'YYYY-MM-DD[T]HH:mm:ss.SSZ',
  dbDateFormat: 'YYYY-MM-DD[T]HH:mm:ss.SSZ',
  dbOnlyDateFormat: 'YYYY-MM-DD[T]00:00:00Z',
  fileDateFormat: 'MMM D, YYYY',
  ESTTimezone: "America/New_York",
  formFieldStatusTypes: [
    { label: "Active", value: "Active" },
    { label: "Pending", value: "Pending" },
    { label: "Inactive", value: "Inactive" }
  ],
  noView: 'noView',
  edit: 'edit',
  view: 'view',
  // templateColor: '#0e4768',
  whiteColor: '#ffffff',
  darkTemplateColor: '#00000045',
  avatarBgColor: 'green',
  blackColor: 'black',
  sourceKey: "qVtYv2x5A7CaFcHeMh",
  paginationPosition: 'top',
  displaySettings: false,
  selectionLimit: 30,
  imageFormats: ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg', '.tiff', '.webp'],
  progressBarClosingTime: 5000,
  defaultRoute: '/users'
};
export default config;
